import Photo from "./Photo";
import { Kicker } from "./bits";
import { T } from "./content";

export default function Fondateur({ lang }) {
  const t = T[lang];
  return (
    <section className="section" id="fondateur" data-testid="section-fondateur">
      <div className="container founder__grid">
        <div className="founder__photo reveal">
          <Photo slug="founder" label={t.founderName} className="photo-img" />
        </div>
        <div className="reveal">
          <Kicker withDash>{t.founderKicker}</Kicker>
          <div className="founder__quote-mark" aria-hidden="true">
            &ldquo;
          </div>
          <blockquote className="founder__quote">{t.founderQuote}</blockquote>
          <div className="founder__sign">
            <span className="founder__badge">MN</span>
            <span>
              <span className="founder__name">{t.founderName}</span>
              <br />
              <span className="founder__role">{t.founderRole}</span>
            </span>
          </div>
        </div>
      </div>

      <div className="container founder__bio" data-testid="founder-bio">
        <div className="founder__bio-text reveal">
          {t.founderBio.map((p, idx) => (
            <p className="founder__para" key={idx}>
              {p}
            </p>
          ))}
        </div>

        <div className="founder__stats reveal" data-testid="founder-stats">
          {t.founderStats.map((s, idx) => (
            <div className="founder__stat" key={idx}>
              <span className="founder__stat-num">{s.num}</span>
              <span className="founder__stat-label">{s.label}</span>
            </div>
          ))}
        </div>

        <p className="founder__langs reveal">{t.founderLangs}</p>
      </div>
    </section>
  );
}
